<template>
	<div class="server-type-box" v-show="lists.length > 0">
		<el-dropdown class="avatar-container right-menu-item hover-effect serve-drop" trigger="click"
			@command="handleCommand">
			<div class="avatar-wrapper">
				<svg-icon :icon-class="status[$store.getters.serviceStatus.name]"
					:class="status[$store.getters.serviceStatus.name]" />
				<span class="user-name"
					v-show="$store.getters.serviceStatus">{{$store.getters.serviceStatus.name}}</span>
				<i class="el-icon-caret-bottom" />
			</div>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item :command="item.id" v-for="(item,index) in lists" :key="item.id">{{ item.name }}
				</el-dropdown-item>
				<!-- <el-dropdown-item :command="$t('server.leisure')">{{ $t('server.leisure') }}</el-dropdown-item>
				<el-dropdown-item :command="$t('server.processing')">{{ $t('server.processing') }}</el-dropdown-item>
				<el-dropdown-item :command="$t('server.cultivate')">{{ $t('server.cultivate') }}</el-dropdown-item>
				<el-dropdown-item :command="$t('server.meeting')">{{ $t('server.meeting') }}</el-dropdown-item>
				<el-dropdown-item :command="$t('server.dine')">{{ $t('server.dine') }}</el-dropdown-item>
				<el-dropdown-item :command="$t('server.rest')">{{ $t('server.rest') }}</el-dropdown-item>
				<el-dropdown-item :command="$t('server.offline')">{{ $t('server.offline') }}</el-dropdown-item> -->
			</el-dropdown-menu>
		</el-dropdown>
		<div class="service-time">
			<span>{{timing.hh}}</span>:
			<span>{{timing.mm}}</span>:
			<span>{{timing.ss}}</span>
		</div>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	export default {
		name: 'ServerType',
		data() {
			return {
				timer: undefined,
				timing: {
					hh: '00',
					mm: '00',
					ss: '00'
				},
				lists: [],
				status: {
					"休息": "im-rest",
					"话后处理中": 'im-processing',
					"培训": 'im-cultivate',
					"吃饭": 'im-dine',
					"空闲": 'im-leisure',
					"离开": 'im-offline',
					"会议": 'im-meeting',
				}
			}
		},
		computed: {
			...mapState({
				brandId: state => state.user.brandId,
				userInfo: state => state.user.userInfo
			}),
		},
		created() {
			if (this.$store.state.permission.menus) {
				let index = this.$store.state.permission.menus.findIndex((el) => el.menuName.indexOf('IM') != -1);
				if (index != -1) {
					if (!this.$store.getters.serviceStatus || Object.keys(this.$store.getters.serviceStatus).length == 0) {
						this.setServiceStatus({
							allowChat: "0",
							createBy: "admin",
							id: 106,
							name: "离开",
							status: "1"
						});
					}
					this.getServiceStatus();

					return;
				}
				this.$store.commit('imChatService/UPDATE_IM_OPERATE_LOGS', {
					type: `该账号【${this.userInfo?.account}】无IM坐席权限`,
					content: `接口permission.menus权限数据为${JSON.stringify(this.$store.state.permission.menus)}`
				})
			}

		},
		methods: {
			...mapActions({
				setServiceStatus: 'user/changeServiceStatus'
			}),
			handleCommand(command) {
				if (command == this.$store.getters.serviceStatus.id) {
					return
				}
				let status = this.lists.filter(el => el.id == command);
				this.$api.setImServiceStatus(this.brandId, status[0].id).then(res => {
					this.$store.commit('imChatService/UPDATE_IM_OPERATE_LOGS', {
						type: `${this.userInfo?.account}切换状态为${status[0].id}`,
						content: `响应：${JSON.stringify(res)}`
					})
					window.clearInterval(this.timer)
					this.setServiceStatus(status[0])
					this.setTimer()
				})

			},
			calcTiming(now, d) {
				let diff = (now - d) / 1000
				let hours = Math.floor(diff / 3600)
				let minutes = Math.floor(diff % 3600 / 60)
				let seconds = Math.floor(diff % (3600) % 60)
				this.timing = {
					hh: hours > 9 ? hours : '0' + hours,
					mm: minutes > 9 ? minutes : '0' + minutes,
					ss: seconds > 9 ? seconds : '0' + seconds
				}
			},

			setTimer() {
				let startTime = new Date().getTime()
				this.timer = setInterval(() => {
					let currentTime = new Date().getTime()
					this.calcTiming(currentTime, startTime)
				}, 1000)
			},
			// 获取所有状态列表
			async getServiceStatus() {
				await this.$api.getImServiceStatus(this.brandId).then(res => {
					if (res.errcode == 0) {
						this.lists = res.data
						if (this.lists.length > 0) {
							let result = JSON.parse(JSON.stringify(this.lists));
							result = result.reverse();
							this.getCurrentStatus()
						}
					}
				})
			},
			async setCurrentStatus() {
				await this.$api.setImServiceStatus(this.brandId, this.$store.getters.serviceStatus.id).then(res => {
					if (res.errcode == 0) {
						this.setTimer()
						this.setServiceStatus(this.$store.getters.serviceStatus);
					}
				})
			},
			getCurrentStatus() {
				this.$api.getCurrentImServiceStatus(this.brandId, {
					status: this.$store.getters.serviceStatus.id
				}).then(res => {
					if (res.errcode == 0) {
						const result = JSON.parse(res.data);
						if (result.status != this.$store.getters.serviceStatus.id) {
							this.setCurrentStatus()
						} else {
							this.setTimer()
						}
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	$txt_gray:#3C4353;

	.server-type-box {
		height: 30px;
		border: 1px solid #CCC;
		border-radius: 15px;
		margin: 15px 15px 0 0;
		color: $txt_gray;
		display: inline-block;
		padding: 0 10px;
		font-size: 18px;
		color: #5a5e66;
		position: relative;
		vertical-align: top;
		box-sizing: border-box;
		cursor: pointer;

		&>.serve-drop {
			vertical-align: top;
			line-height: 28px;
			margin-top: -33px;
			vertical-align: middle;
			padding-right: 8px;
			box-sizing: border-box;
			border-right: 1px solid #CCC;

			&>.avatar-wrapper {
				vertical-align: top;
				box-sizing: border-box;
			}

			& .user-name {
				vertical-align: top;
				display: inline-block;
				padding: 0 3px;
				box-sizing: border-box;
			}

			.svg-icon {
				color: #ff504dff;
			}

			.im-leisure {
				color: #47b267;
			}
		}

		&>.service-time {
			display: inline-block;
			vertical-align: top;
			line-height: 28px;
			font-size: 14px;
			padding-left: 8px;
			box-sizing: border-box;
			font-weight: 600;
		}
	}
</style>
